import React from 'react';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-400 py-12" data-id="element-46">
      <div className="container mx-auto px-6 max-w-6xl flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-47">
        <div className="text-center md:text-left" data-id="element-48">
          <h3 className="text-white font-fredoka font-bold text-xl mb-2" data-id="element-49">
            ✏️ Método Escribo Jugando
          </h3>
          <p className="text-sm" data-id="element-50">Transformando el aprendizaje infantil.</p>
        </div>

        <div className="flex gap-6 text-sm" data-id="element-51">
          <a href="#" className="hover:text-white transition-colors" data-id="element-52">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-53">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-54">
            Contacto
          </a>
        </div>
      </div>
      <div className="container mx-auto px-6 max-w-6xl mt-8 pt-8 border-t border-slate-800 text-center text-sm" data-id="element-55">
        <p data-id="element-56">
          &copy; {new Date().getFullYear()} Método Escribo Jugando. Todos los
          derechos reservados.
        </p>
      </div>
    </footer>;
}